import { render, staticRenderFns } from "./PrivateOrderDetail.vue?vue&type=template&id=15949621&scoped=true&"
import script from "./PrivateOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PrivateOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PrivateOrderDetail.vue?vue&type=style&index=0&id=15949621&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15949621",
  null
  
)

export default component.exports